import { useSeo } from "../lib/seo";
import { useEffect, useState } from "react";
import { Loader2, Star } from "lucide-react";
import RALayout from "../components/ra/RALayout";
import VideoReviewCard from "../components/ra/VideoReviewCard";
import { api } from "../lib/adventureApi";

export default function VideoReviews() {
  useSeo({ title: "Video reviews from our travellers | Responsible Adventures", description: "Real travellers share their Responsible Adventures journeys on video." });
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/video-reviews").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);

  return (
    <RALayout>
      <section className="max-w-7xl mx-auto px-5 sm:px-8 pt-16 pb-24" data-testid="reviews-page">
        <div className="flex items-center gap-1.5 mb-4">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-terracotta text-terracotta" />)}
        </div>
        <h1 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl tracking-tight max-w-3xl">Straight from the trail.</h1>
        <p className="mt-4 text-ink-secondary max-w-xl text-base">Unscripted video reviews recorded by our travellers after their adventures with Responsible Adventures.</p>
        <div className="mt-12">
          {items === null ? (
            <Loader2 className="w-6 h-6 animate-spin text-terracotta" />
          ) : items.length === 0 ? (
            <p className="text-ink-secondary" data-testid="reviews-empty">Video reviews are on their way — check back soon.</p>
          ) : (
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6" data-testid="reviews-grid">
              {items.map((r) => <VideoReviewCard key={r.token} review={r} />)}
            </div>
          )}
        </div>
      </section>
    </RALayout>
  );
}
